import { Outlet } from "react-router-dom"



export default function MediaDashOut() {
  return (
    <div className="blogDashboard" style={{width:"100%"}}>
   <h1>Dashbord Media Out</h1>
    <Outlet/>
        
    </div>
  )
}
